import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Image from '../i/icons_d.png';

const styles = {
  servicesWrapper: {
    margin: '55px 0 0 0',
    position: 'relative',
  },
  box: {
    width: '1112px',
    margin: 'auto',
  },
  landingHeading: {
    fontSize: '35px',
    fontWeight: '500',
    color: '#fff',
    textAlign: 'center',
    margin: 0,
    padding: 0,
  },
  landingDescTxt: {
    lineHeight: '27px',
    fontSize: '13px',
    color: '#fff',
    textAlign: 'center',
    width: '758px',
    margin: 'auto',
    padding: '25px 0 53px 0',
  },
  widgetsList: {
    margin: '20px 0 0 0',
  },
  widgets: {
    width: '322px',
    float: 'left',
    minHeight: '421px',
    backgroundColor: '#fff',
    textDecoration: 'none',
    WebkitBoxShadow: '0px 0px 21px 3px rgba(0,0,0,0.06)',
    MozBoxShadow: '0px 0px 21px 3px rgba(0,0,0,0.06)',
    boxShadow: '0px 0px 21px 3px rgba(0,0,0,0.06)',
    margin: '0 70px 0 0',
    position: 'relative',
    borderRadius: '10px',
    '&:nth-child(3)': {
      margin: 0,
    },
  },
  iconBox: {
    height: '180px',
    position: 'relative',
  },
  icon: {
    display: 'block',
    background: `url(${Image}) no-repeat`,
    backgroundSize: '750px 340px',
  },
  videoIcon: {
    width: '92px',
    height: '70px',
    backgroundPosition: '-292px 0',
    margin: 'auto',
    position: 'absolute',
    top: '62px',
    left: '0',
    right: '0',
  },
  msgIcon: {
    width: '86px',
    height: '78px',
    backgroundPosition: '-406px 0',
    margin: 'auto',
    position: 'absolute',
    top: '65px',
    left: '0',
    right: '0',
  },
  autnIcon: {
    width: '76px',
    height: '86px',
    backgroundPosition: '-508px 0',
    margin: 'auto',
    position: 'absolute',
    top: '60px',
    left: '0',
    right: '0',
  },
  subHeading: {
    fontSize: '24px',
    color: '#334956',
    fontWeight: '500',
    display: 'block',
    textAlign: 'center',
    padding: '0 0 10px 0',
  },
  widgetDescription: {
    fontSize: '14px',
    color: '#464646',
    lineHeight: '22px',
    padding: '0 62px',
    textAlign: 'center',
  },
  bendsIcon1: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    height: '85px',
    backgroundSize: 'cover',
  },
  bendsIcon2: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    height: '69px',
    backgroundSize: 'cover',
  },
  bendsIcon3: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    height: '59px',
    backgroundSize: 'cover',
  },
  clearfix: {
    clear: 'both',
  },
};
const services = [
  {
    iconClass: 'videoIcon',
    subHeading: 'Video & Voice',
    description:
      'Enable apps to make voice or video calls around the globe and design workflows with programmatic call control.',
    benIconClass: 'bendsIcon1',
    link: '/docs/doc1.html',
  },
  {
    iconClass: 'msgIcon',
    subHeading: 'Messaging',
    description:
      'Send and receive global SMS, MMS, and IP messaging from any app, and ensure deliverability using Event Manager real time features.',
    benIconClass: 'bendsIcon2',
  },
  {
    iconClass: 'autnIcon',
    subHeading: 'Authentication',
    description:
      'Add authentication to your mobile or web apps and use it with our services or your own application servers.',
    benIconClass: 'bendsIcon3',
    link: '/docs/aum_doc1.html',
  },
];
const ServicesAndFeatures = ({ classes }) => (
  <div className={classes.servicesWrapper}>
    <div className={classes.box}>
      {/* <h4 className={classes.landingHeading}>Our Services/Features</h4>
      <p className={classes.landingDescTxt}>
            555 provides Video/Voice, Messaging, and Authentication.
      </p> */}
      <div className={classes.widgetsList}>
        {services.map(item => (
          <a
            href="https://www.555.comcast.com"
            className={classes.widgets}
            key={item.subHeading}
          >
            <div className={classes.iconBox}>
              <span className={classNames(classes.icon, classes[item.iconClass])} />
            </div>
            <span className={classes.subHeading}>{item.subHeading}</span>
            <p className={classes.widgetDescription}>{item.description}</p>
            <span className={classes[item.benIconClass]} />
          </a>
        ))}
        <div className={classes.clearfix} />
      </div>
    </div>
  </div>
);

export default withStyles(styles)(ServicesAndFeatures);

ServicesAndFeatures.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

ServicesAndFeatures.defaultProps = {
  classes: {},
};
